import { exporter } from '@sde/widgets-core/src/tools/exporter';
import { Widget } from './widget';
import { reducers } from './state/modules';

export const ProviderSelect = exporter(Widget, { reducers });
